export class BugReportModel {
    id?: number;
    extensionName?: string | undefined;
    name?: string | undefined;
    description?: string | undefined;
}
